<template>
	<div class="creditmanagement">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">会员积分管理</div>
					<div class="contentcard">
						<div style="font-size: 16px;">当前用户积分值:{{creditvalue/exchange_rate||0}}</div>
					</div>
					<div class="contentcard">
						<div>
							<div>
								<div v-if="!creditlist.length">
									<a-alert message="查询结果为空" banner type="info" />
								</div>
								<div v-if="creditlist.length">
									<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
										<a-col :span="3" style="text-align: center;">积分类型</a-col>
										<a-col :span="3" style="text-align: center;">积分数值</a-col>
										<a-col :span="3" style="text-align: center;">记录时间</a-col>
										<a-col :span="3" style="text-align: center;">是否验证</a-col>
										<a-col :span="3" style="text-align: center;">操作</a-col>
									</a-row>
								</div>
								<div style="color: #666;font-size: 14px;" v-for="credit in creditlist" :key="credit">
									<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px 0;">
										<a-col :span="3" style="text-align: center;">{{credit.credit_type}}</a-col>
										<a-col :span="3" style="text-align: center;">{{credit.value/exchange_rate}}</a-col>
										<a-col :span="3" style="text-align: center;">{{moment(credit.created_at).format('YYYY-MM-DD HH:mm:ss')}}</a-col>
										<a-col :span="3" style="text-align: center;" v-if="!credit.modify">
											<a-icon type="check-circle" style="color: green;" v-if="credit.check_out" />
											<a-icon type="close-circle" style="color: red;" v-else />
										</a-col>
										<a-col :span="3" style="text-align: center;" v-if="credit.modify">
											<a-button icon="check-circle" style="color: green;" v-if="credit.check_out" @click="modifystatus(credit)" />
											<a-button icon="close-circle" style="color: red;" v-else @click="modifystatus(credit)" />
										</a-col>
										<a-col :span="3" style="text-align: center;" v-if="!credit.modify">
											<a-button type="primary" size="small" style="font-size: 12px;width: 96px;" @click="modifybtn(credit)">修改</a-button>
										</a-col>
										<a-col :span="3" style="text-align: center;" v-if="credit.modify">
											<a-button type="primary" size="small" style="font-size: 12px;width: 96px;" @click="savebtn(credit)">保存</a-button>
										</a-col>
									</a-row>
								</div>
							</div>
						</div>
						<div style="text-align: center;margin-top: 15px;">
							<a-button type="primary" @click="creditbtn">添加积分</a-button>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

		<a-modal title="添加积分" :visible="credit_visible" @ok="credit_Ok" :confirmLoading="creditLoading" @cancel="credit_Cancel">
			<div style="">
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">积分类型</span>
					<a-input style="width: 250px;" v-model="credit_info.credit_type" placeholder="请输入积分类型" />
				</div>
				<div style="margin: 10px 0;"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">积分值</span>
					<a-input-number style="width: 250px;" v-model="credit_info.value" placeholder="请输入积分值" />
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import moment from 'moment';

	export default {

		data() {
			return {
				current: ['membermanagement'],
				openKeys: [''],
				creditlist: [],
				creditvalue: 0,
				exchange_rate: 0,
				credit_visible: false,
				creditLoading: false,
				credit_info: {
					credit_type: null,
					value: 0
				},

			}
		},
		created: function() {
			var self = this;
			var params = {
				id: this.$route.query.id,
				user_from_app: this.$route.query.user_from_app
			}
			this.$axios.get('/member/credit/get', {
				params: params
			}).then(function(res) {
				for (var i = 0; i < res.data.creditlist.length; i++) {
					res.data.creditlist[i].modify = false;
				}
				self.creditlist = res.data.creditlist;
				self.exchange_rate = res.data.exchange_rate;
				self.creditvalue = res.data.creditvalue;

			});
		},
		methods: {
			moment,
			modifybtn(credit) {
				credit.modify = true;
			},
			modifystatus(credit) {
				credit.check_out = !credit.check_out;
			},
			savebtn(credit) {
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否保存修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						credit.modify = false;
						var params = {
							id: credit.id,
							check_out: credit.check_out
						}
						self.$axios.post('member/credit/update', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.$axios.get('/member/credit/get', {
								params: {
									id: self.$route.query.id,
									user_from_app: self.$route.query.user_from_app
								}
							}).then(function(res) {
								for (var i = 0; i < res.data.creditlist.length; i++) {
									res.data.creditlist[i].modify = false;
								}
								self.creditlist = res.data.creditlist;
								self.exchange_rate = res.data.exchange_rate;
								self.creditvalue = res.data.creditvalue;

							});
						})
					},
					onCancel() {},
				});
			},
			creditbtn() {
				this.credit_visible = true;
			},
			credit_Cancel(){
				this.credit_visible = false;
				this.credit_info = {
					credit_type: null,
					value: 0
				}
			},
			credit_Ok(){
				if (!this.credit_info.credit_type) {
					return this.$message.error("积分类型不能为空");
				}
				if (!this.credit_info.value) {
					return this.$message.error("积分值不能为空");
				}
				this.creditLoading = true;
				this.credit_info.user_id = this.$route.query.id;
				this.credit_info.check_out = true;
				this.credit_info.value *=this.exchange_rate;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否确认添加',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('member/credit/addlog', {
							params: self.credit_info
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.credit_visible = false;
							self.credit_info = {
								credit_type: null,
								value: 0
							}
							self.creditLoading = false;
							self.$axios.get('/member/credit/get', {
								params: {
									id: self.$route.query.id,
									user_from_app: self.$route.query.user_from_app
								}
							}).then(function(res) {
								for (var i = 0; i < res.data.creditlist.length; i++) {
									res.data.creditlist[i].modify = false;
								}
								self.creditlist = res.data.creditlist;
								self.exchange_rate = res.data.exchange_rate;
								self.creditvalue = res.data.creditvalue;
							
							});
							
						})
					},
					onCancel() {
						self.expressLoading = false;
					},
				});
				
			}


		},

	};
</script>

<style>

	.creditmanagement .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?6ccc3983